<div class="relative">
    <div class="top">
        <div class="topTitle">
            <h1 class="middle-blue" tabindex="0">חיפוש מכרזים</h1>
        </div>
        <div class="topImg"></div>
    </div>
    <router-outlet></router-outlet>
    <!--<div>
        <app-search-result [settings]="viewTendersSettings" (onInit)="initSearchResult($event)"></app-search-result>
    </div>-->
    <mat-spinner class="margin-auto" *ngIf="loading==true && close==false"></mat-spinner>
    <div *ngIf="error!=''">{{error}}</div>
    <div *ngIf="close==false" [@leaveAnimation] [@enterAnimation]>
        <div class="searchResults relative1" *ngIf="loading==false && error==''">
            <div class="light-blue pointer only-mobile-old" (click)="showExSearch=!showExSearch"> 
                <span>חיפוש מורחב</span> 
                <mat-icon *ngIf="showExSearch==false">expand_more</mat-icon>
                <mat-icon *ngIf="showExSearch==true">expand_less</mat-icon>
            </div>
            <div class="exSearch" [ngClass]="{'mobile-hide-old':showExSearch==false}">
                <form>
                    <div class="ex-search-params">
                        <div class="row mobile-col">
                            <div class="one-prop flex-2">
                                <mat-form-field class="mat-form-field-infix-center">
                                    <mat-label class="label gray">חיפוש חופשי</mat-label>
                                    <input matInput placeholder="הקלד/הקלידי כאן את החיפוש שלך" [(ngModel)]="searchObj.FreeText" name="txt_freeText" (input)="filter()"/>
                                </mat-form-field>
                            </div>
                            <div class="row flex-1">
                                <div class="one-prop flex-1">
                                    <mat-form-field class="mat-form-field-infix-center">
                                        <mat-label class="label gray">מספר מכרז</mat-label>
                                        <input placeholder="מספר מכרז" matInput name="txt_MolsaTenderNumber" [(ngModel)]="searchObj.MolsaTenderNumber" (input)="filter()"/>
                                    </mat-form-field>
                                </div>
                                <div class="one-prop flex-1 only-mobile mat-field-select">
                                    <mat-form-field class="mat-form-field-infix-center">
                                        <mat-label class="label gray">סטטוס</mat-label>
                                        <mat-select placeholder="סטטוס" class="select" [(ngModel)]="searchObj.MolsaTenderStatus" name="ddl_MolsaTenderStatus" multiple (selectionChange)="filter()">
                                            <mat-option *ngFor="let x of TenderStatuses;let i=index" [value]="x.key">{{x.value}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row mobile-col">
                            <div class="row flex-2">
                                <div class="one-prop flex-1">
                                    <mat-form-field>
                                        <mat-label>מועד פרסום החל מ-</mat-label>
                                        <input matInput [matDatepicker]="datepicker" [(ngModel)]="searchObj.MolsaTenderPublishDate_start" name="txt_MolsaTenderPublishDate_start" (dateInput)="filter()" aria-label="הזן תאריך עבור מכרזים שפורסמו החל מתאריך זה"/>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="datepicker" label="בחר תאריך עבור מכרזים שפורסמו החל מתאריך זה" aria-label="בחר תאריך עבור מכרזים שפורסמו החל מתאריך זה"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                        <mat-error>{{getDateError('txt_MolsaTenderPublishDate_start')}}</mat-error>
                                    </mat-form-field>
                                    <span class="only-mobile w-100"></span>
                                </div>
                                <div class="one-prop flex-1">
                                    <mat-form-field class="mat-field-date mat-form-field-infix-center">
                                        <mat-label class="label gray">מועד הגשה אחרון החל מ-</mat-label>
                                        <input placeholder="בחר מועד הגשה" matInput [matDatepicker]="datepicker2" name="txt_MolsaProposalHandingDate_start" [(ngModel)]="searchObj.MolsaProposalHandingDate_start" (dateInput)="filter()" aria-label="הזן תאריך עבור מכרזים שמועד הגשה אחרון החל מתאריך זה" />
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="datepicker2" label="בחר תאריך עבור מכרזים שמועד הגשה אחרון החל מתאריך זה" aria-label="בחר תאריך עבור מכרזים שמועד הגשה אחרון החל מתאריך זה"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker2></mat-datepicker>
                                        <mat-error>{{getDateError('txt_MolsaProposalHandingDate_start')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="one-prop flex-1 mobile-hide mat-field-select">
                                <mat-form-field>
                                    <mat-label class="label gray">סטטוס</mat-label>
                                    <mat-select aria-placeholder="סטטוס" class="select" [(ngModel)]="searchObj.MolsaTenderStatus" name="ddl_MolsaTenderStatus" multiple (selectionChange)="filter()">
                                        <mat-option *ngFor="let x of TenderStatuses;let i=index" [value]="x.key">{{x.value}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="top-details row">
                <div class="flex-3 row baseline mobile-col">
                    <span class="flex-3 mobile-col">
                        <span class="details-title"><h2 tabindex="0">תוצאות חיפוש</h2></span>
                        <span class="details-summary">{{resultCountMsg}}</span>
                    </span>
                </div>
                <div class="order-by">
                    <mat-form-field>
                        <mat-label class="label gray">מיין לפי</mat-label>
                        <mat-select class="select" [(ngModel)]="orderBy" name="ddl_OrderBy" (selectionChange)="order()">
                            <mat-option value=""></mat-option>
                            <mat-option value="Title">שם המכרז</mat-option>
                            <mat-option value="MolsaTenderNumber">מספר המכרז</mat-option>
                            <mat-option value="MolsaTenderPublishDate">מועד פרסום</mat-option>
                            <mat-option value="MolsaProposalHandingDate">מועד הגשה אחרון</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!--<div class="order-by">
                    <div class="mat-form-field mat-form-field-can-float mat-form-field-should-float">
                        <div class="mat-form-field-wrapper">
                            <div class="mat-form-field-flex">
                                <div class="mat-form-field-infix">
                                    <select class="mat-select" [(ngModel)]="orderBy" name="ddl_OrderBy1" id="ddl_OrderBy1" (change)="order()">
                                        <option class="mat-option" value=""></option>
                                        <option class="mat-option" value="Title">name</option>
                                        <option class="mat-option" value="MolsaTenderNumber">number המכרז</option>
                                        <option class="mat-option" value="MolsaTenderPublishDate">מועד publish</option>
                                        <option class="mat-option" value="MolsaProposalHandingDate">last הגשה אחרון</option>
                                    </select>
                                </div>
                                <span class="mat-form-field-label-wrapper">
                                    <span class="mat-form-field-label">
                                        <label class="label gray" for="ddl_OrderBy1">sort by</label>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>
            <div class="results">
                <div class="one-res" *ngFor="let row of tenders.slice((startPage-1)*pageSize,startPage*pageSize)">
                    <app-tender [tender]="row" (onSelectTender)="onSelectTender($event)"></app-tender>
                </div>
            </div>
            <div class="details row" *ngIf="tenders.length>0">
                <span class="details-summary mobile-hide">{{resultCountMsg}}</span>
                <div class="paging only-mobile" *ngIf="tenders.length>pageSize">
                    <span class="span-as-link" (click)="paging(-1,'prev')" tabindex="0" (keyup.enter)="paging(-1,'prev')" role="link" aria-label="לעמוד הראשון"><<</span>
                    <span class="span-as-link" (click)="paging(0,'prev')" tabindex="0" (keyup.enter)="paging(0,'prev')" role="link" aria-label="לעמוד הקודם">הקודם</span>
                </div>
                <div class="paging" *ngIf="tenders.length>pageSize">
                    <span [class]="startPage==i?'cur-page':'span-as-link'" *ngFor="let i of pages" (click)="paging(i,'')" [tabindex]="startPage==i?'-1':'0'" (keyup.enter)="paging(i,'')" role="link" [attr.aria-label]="'לעמוד '+i">{{i}}</span>
                </div>
                <div class="paging" *ngIf="tenders.length>pageSize">
                    <span class="span-as-link mobile-hide" (click)="paging(-1,'prev')" tabindex="0" (keyup.enter)="paging(-1,'prev')" role="link" aria-label="לעמוד הראשון"><<</span>
                    <span class="span-as-link mobile-hide" (click)="paging(0,'prev')" tabindex="0" (keyup.enter)="paging(0,'prev')" role="link" aria-label="לעמוד הקודם">הקודם</span>
                    <span class="span-as-link" (click)="paging(0,'next')" tabindex="0" (keyup.enter)="paging(0,'next')" role="link" aria-label="לעמוד הבא">הבא</span>
                    <span class="span-as-link" (click)="paging(-1,'next')" tabindex="0" (keyup.enter)="paging(-1,'next')" role="link" aria-label="לעמוד האחרון">>></span>
                </div>
            </div>
        </div>
    </div>
</div>
